module.exports = __webpack_public_path__ + "419e290abf97d03dd1340108019cda11.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/twitter.png
 ** module id = 1546
 ** module chunks = 0
 **/